import styled from 'styled-components'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const InputWrapper = styled.div<{ $hasError: boolean }>`
  width: 100%;

  .ant-input-affix-wrapper {
    display: block;
    width: 100%;
  }

  .ant-input-affix-wrapper .ant-input {
    box-sizing: border-box;
    height: 40px;
    padding: 8px 56px 8px 12px;
    border: 2px solid ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')};
    border-radius: 4px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 24px;
    color: #363636;
    background: #fff;
    box-shadow: none;

    &:hover {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
    }

    &:focus {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
      box-shadow: none;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
    }

    &:disabled {
      background: #f5f5f5;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .ant-input-affix-wrapper .ant-input-suffix {
    color: #757575;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 24px;
  }
`
